import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    BaseRouteReuseStrategy,
    Params,
} from '@angular/router';

/**
 * Makes a page afresh when its route's parameters change, as from /students/A/enrolments to
 * /students/B/enrolments. Angular's default keeps the page, but the pages here read their record's
 * id and resolved data once, when they are made, so a kept page would go on showing the first
 * record, and saving to it. A route made afresh brings its children with it, so a record's tabs
 * follow. A change of query parameters still keeps the page: a list's filter, a report's period,
 * a travel tab's dates.
 */
@Injectable()
export class RecordReuseStrategy extends BaseRouteReuseStrategy {
    override shouldReuseRoute(
        future: ActivatedRouteSnapshot,
        curr: ActivatedRouteSnapshot
    ): boolean {
        return (
            super.shouldReuseRoute(future, curr) &&
            sameParams(future.params, curr.params)
        );
    }
}

function sameParams(a: Params, b: Params): boolean {
    const keys = Object.keys(a);

    return (
        keys.length === Object.keys(b).length &&
        keys.every((key) => a[key] === b[key])
    );
}
